import { TicketingEventDetails } from './event-details-ticketing';
import { TicketingTickets } from './tickets-ticketing';

/**
 * Blueprint for the order status part of ticketing object.
 */
export class TicketingEvents {
  public eventId: number;
  public ticketCount: number;
  public eventDetails: TicketingEventDetails;
  public tickets: Array<TicketingTickets>;

  constructor(data?: any) {
    this.eventId = data.eventId;
    this.ticketCount = data.ticketCount;
    this.eventDetails = new TicketingEventDetails(data.eventDetails);

    this.tickets = [];
    data.tickets.forEach(ticket => {
      this.tickets.push(new TicketingTickets(ticket));
    });
  }

  get eventAndTicket(): string {
    if (!this.eventDetails.homePerformer && !this.eventDetails.guestPerformer) {
      return `${this.eventDetails.name} (${this.tickets.length})`;
    }

    let formattedEventName: string = '';

    if (this.eventDetails.homePerformer) {
      formattedEventName = this.eventDetails.homePerformer;
    }

    if (this.eventDetails.homePerformer && this.eventDetails.guestPerformer) {
      formattedEventName = `${formattedEventName} - `;
    }

    if (this.eventDetails.guestPerformer) {
      formattedEventName = `${formattedEventName}${this.eventDetails.guestPerformer}`;
    }

    return `${formattedEventName} (${this.tickets.length})`;
  }

}
